function filterBy(list, value) {
  return list.filter(function (user) {
    return user.business_name.toLowerCase().indexOf(value) >= 0;
  });
}

function formatPrice(value) {
  let val = (value / 1).toFixed(2)
  return !isNaN(val) ? val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0
}

function formatPriceProject(value) {
  let val = (value / 1).toFixed(0)
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}

function parseValue(string) {
  var pattern = /\$|\,/ig;
  return parseInt(string.replace(pattern, ''))
}

function formatMoney(n) {
  return Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN'
  }).format(n);
}

export {filterBy, formatPrice, parseValue, formatPriceProject, formatMoney}
